var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"message",staticClass:"message-text",class:{ 'mouse-down': _vm.mouseDown, kakaoMode: _vm.$kakaoMode() },domProps:{"innerHTML":_vm._s(_vm.msg)},on:{"mousedown":_vm.onMouseDown,"mouseup":_vm.onMouseUp}})}
var staticRenderFns = []

export { render, staticRenderFns }